export const useCancelEmailUpdate = async (data) => {
  return useFetchSafely(() => `profile/update`, {
    method: "PUT",
    body: data,
  });
};

export const useResendConfirmationEmail = async (userId, token) => {
  return useFetchSafely(() => `/updated-email/verification-notification/${userId}/${token}`);
};
